module.exports = "../../app/cells/components/banner/signup_banner_cell.rb";